/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { ListeContainer, useListe } from '@mairistem/liste';

import { FILTRE_NUMERISES } from '@/constants';

import ActeReconnaissanceListe from './ActeReconnaissanceListe';

interface ActeReconnaissanceListeContainerProps {
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeReconnaissanceListeContainer = ({
  sidebar,
}: ActeReconnaissanceListeContainerProps = {}) => {
  const [service] = useListe(
    '/api/administres/etat-civil/numerisation-actes/liste',
    { type_acte: 'reconnaissance', ...FILTRE_NUMERISES },
  );

  return (
    <ListeContainer
      type="actes"
      contains="liste"
      service={service}
      perPage={20}
    >
      <ActeReconnaissanceListe sidebar={sidebar} />
    </ListeContainer>
  );
};

export default ActeReconnaissanceListeContainer;
